import { BrowserRouter as Router } from "react-router-dom";
import { useEffect } from "react";
import { useAuthStore } from "@/pages/auth/auth.store";
import { UpdateNotification } from "./shared/components/UpdateNotification";
import { AppRoutes } from "./routes";
import { Toaster } from "sonner";

function App() {
  const { isAuthenticated, isLoading, checkAuth } = useAuthStore();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#0F1524] text-white flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-white"></div>
      </div>
    );
  }

  return (
    <Router>
      <div className="min-h-screen bg-[#0F1524] text-white">
        <AppRoutes isAuthenticated={isAuthenticated} />
        <UpdateNotification />
        <Toaster position="top-right" />
      </div>
    </Router>
  );
}

export default App;
